module.exports = __webpack_public_path__ + "img/ceara-login.10d350f9.png";